export enum TicketIncidentSubStatusEnum {
  WAITING_VALIDATION = 'WAITING_VALIDATION',
  REFERAL_VALIDATED = 'REFERAL_VALIDATED',
  VALIDATED_WITH_CONTRACT = 'VALIDATED_WITH_CONTRACT',
}
